export type Theme = "clair" | "sombre";

export const CLE_STOCKAGE_THEME = "portail-theme";

function estTheme(valeur: string | null): valeur is Theme {
  return valeur === "clair" || valeur === "sombre";
}

/** Thème du système, quand le visiteur n'a jamais choisi. */
export function themeDuSysteme(): Theme {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "clair";
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "sombre" : "clair";
}

/** Choix retenu de la visite précédente, ou celui du système. */
export function themeInitial(): Theme {
  try {
    const memorise = window.localStorage.getItem(CLE_STOCKAGE_THEME);
    if (estTheme(memorise)) {
      return memorise;
    }
  } catch {
    // Stockage indisponible (navigation privée, blocage) : on suit le système.
  }
  return themeDuSysteme();
}

/** Pose le thème sur la page sans le mémoriser : un choix du système n'est pas un choix du visiteur. */
export function poserTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
}

/** Choix du visiteur : posé et mémorisé d'une visite à l'autre. */
export function appliquerTheme(theme: Theme): void {
  poserTheme(theme);
  try {
    window.localStorage.setItem(CLE_STOCKAGE_THEME, theme);
  } catch {
    // Le thème s'applique quand même : seule la mémoire d'une visite à l'autre est perdue.
  }
}
